import React from "react";
import "@frameworks/shared-library/stylesheets/components/FolioSelection/FolioSelection.scss";
import { roundUpToThreeDecimalPlaces } from "@domains/utils/numberMethods";
export var InvestmentItem = function (_a) {
    var amount = _a.amount, units = _a.units, folioNumber = _a.folioNumber, isSelected = _a.isSelected, onSelect = _a.onSelect, isSelectedRadio = _a.isSelectedRadio, holdingType = _a.holdingType;
    return (React.createElement("div", { className: "d-flex align-items-center flex-column  primary-investment-folio-container", onClick: onSelect, role: "button", tabIndex: 0 },
        React.createElement("div", { className: "d-flex align-items-center cardContent" },
            !isSelected && (React.createElement("div", { className: "d-flex align-items-center justify-content-center  selectionArea" }, isSelectedRadio ? (React.createElement("p", { className: "circle-selected" })) : (React.createElement("p", { className: "circle" })))),
            React.createElement("div", { className: "d-flex  flex-column  investmentDetails" },
                React.createElement("div", { className: "cardContent" },
                    React.createElement("div", { className: "amount DMSanN_14_300" },
                        " ",
                        "\u20B9",
                        roundUpToThreeDecimalPlaces(+amount)),
                    React.createElement("div", { className: "unitsContainer DMsanR_10_400" },
                        React.createElement("div", { className: "units" },
                            "Units: ",
                            roundUpToThreeDecimalPlaces(+units)))),
                React.createElement("div", { className: "folioNumber DMSanN_14_300" },
                    "Folio no.",
                    folioNumber,
                    " ",
                    React.createElement("p", { className: "circlepoint" }),
                    React.createElement("span", { className: "DMSansNormal_12_400 holdingType" }, holdingType))))));
};
